import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button ,DropdownItem , DropdownMenu ,
 Nav , NavItem, Dropdown , DropdownToggle,Label,FormGroup, Input,InputGroup} from 'reactstrap';
 import { TabContent, TabPane,  NavLink, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import ReactTable from "react-table";
import "react-table/react-table.css";


import * as actions from '../../actions/movimientocaclientes';
// import Modal from "./Modal";
import _ from "lodash";
import {api} from '../../actions/_request';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import moment from 'moment';
import Select from 'react-select';
import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import ModalTablas from '../../components/catalogos/modal_tablas';
import ProductosModal from "./ProductosModal";

// 8410

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);



   
class EmbarqueModal extends React.Component
{
     constructor(props)
    {
        super(props)

        this.state = {
            compra: {
                id:0,
                cliente_id:0,
                movimiento_id:0,
                factura_id:0,
                importe:'0.00',
                descuento:'0.00',
                subtotal:'0.00',
                ieps:'0.00',
                impuestos:'0.00',
                total:'0.00',
                fecha: moment().format('Y-MM-DD'),
                concepto:'',
                referencia:'',
                tipo:1,
                forma_pago:1,
                rfc_ordenante:'',
                nombre_banco_extranjero:'',
                cuenta_ordenante:'',
                rfc_banco_beneficiario:'',
                cuenta_beneficiario:'',
                tipo_cadena_pago:'',
                correo:'',
                certificado_pago:'',
                cadena_pago:'',
                sello_pago:'',
                tipo_movimiento_id:1,
                             
            },
            factura:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"",
            naturaleza:'',

        
           
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
       


        

        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
                 
    }
    handleClose (event) {
        console.log('evento--->',event)
         
        let {compra} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla="";
        let bandera_proveedor=true;

        
         switch (name) {
            case "factura_codigo":                  
                  campo = "factura_id";
                  tabla="/busqueda_facturas_cliente_abonos/"+compra.cliente_id;
                  if(parseInt(compra.cliente_id)==0)
                    bandera_proveedor=false;

                  break;
            case "proveedor_codigo":                                  
                  campo = "cliente_id";
                  tabla="/busqueda_cliente";                   
                  break;
            case "movimiento_codigo":                 
                  campo = "movimiento_id";
                  tabla="/busqueda_movimiento";
                  break;      
        }
        let self =this;
        if(value!=""&&bandera_proveedor){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        /*aqui va el request para buscar el saldo*/
                        let  retorno=response.data
                         self.retorno(retorno,campo,vaciar,value);                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }                            
                   
                }

            });
        }else{
           if(bandera_proveedor==false){
            swal("Oops..", "Selecciona un Cliente");

          }
            self.retorno([],campo,1,value); 
        }
   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        let saldo="$0.00";
        let credito="$0.00";
        let bandera=false;
        console.log('renglon---->',objeto);
        let {compra} = this.state;
        let self =this;
        
         if(vacio==1){
          console.log('vaciar')
          codigo=valor;
          descripcion="";
          compra[campo] =0;
         }

         console.log('descripcion--->',descripcion);

         switch (campo) {
            case "cliente_id":
                if(vacio==1){
                  console.log('vaciar')
                  compra[campo] =0;
                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:valor,
                        proveedor_descripcion:'',
                        saldo_proveedor:'$0.00',
                        modal:false,         
                    }) 
                 }else{
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  compra.cuenta_ordenante = objeto.cuenta?objeto.cuenta:objeto.cuenta;
                  compra.rfc_ordenante = objeto.rfc_banco?objeto.rfc_banco:objeto.rfc_banco;
                  compra.nombre_banco_extranjero = objeto.nombre_banco?objeto.nombre_banco:objeto.nombre_banco;

                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:objeto.value?objeto.value:objeto.id,
                        proveedor_descripcion:objeto.label?objeto.label:objeto.nombre,
                        saldo_proveedor:objeto.saldo,
                        modal:false,         
                    }) 

                 }  
                  break;
            case "factura_id":
                  if(vacio==1){
                    console.log('vaciar')
                    codigo=valor;
                    descripcion="";
                    compra[campo] =0;
                    compra.subtotal = '0.00';
                    compra.importe = '0.00';
                      compra.impuestos = '0.00';
                      compra.total = '0.00';
                     self.setState({
                        factura:[],
                        compra : compra,           
                        factura_codigo:valor,
                        factura_descripcion:'',
                        saldo_documento:'$0.00',
                        saldo_original:'$0.00',
                        subtotal_documento:'$0.00',
                        impuesto_documento:'$0.00',
                        modal:false,         
                    }) 
                   }else{
                     codigo=objeto.factura;
                      descripcion=objeto.concepto;
                      campo_codigo="factura_codigo";
                      campo_descripcion="factura_descripcion"; 
                      compra[campo] = objeto.value?objeto.value:objeto.id;
                      compra.subtotal = objeto.subtotal_numero;
                      compra.importe = objeto.subtotal_numero;
                      compra.impuestos = objeto.impuesto_numero;
                      compra.total = objeto.saldo_numero;
                      // if(parseInt(objeto.tipo_doc)==2){
                        // compra.rfc_ordenante='N/A';
                        // compra.nombre_banco_extranjero='N/A';
                        // compra.rfc_banco_beneficiario='N/A';
                        // compra.cuenta_beneficiario='N/A';
                        // compra.tipo_cadena_pago='N/A';
                        // compra.correo='N/A';
                      // }
                       self.setState({
                        factura:objeto,
                        compra : compra,           
                        [campo_codigo]:codigo,
                        [campo_descripcion]:descripcion,
                        saldo_documento:objeto.saldo,
                        saldo_original:objeto.total,
                        subtotal_documento:objeto.subtotal,
                        impuesto_documento:objeto.impuesto,
                        modal:false,         
                  })
                   }
                 
                  break;
            case "movimiento_id":
                  if(vacio==1){
                    codigo=valor;
                    descripcion="";
                    compra[campo] =0;
                    compra.tipo =0;
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:valor,
                        movimiento_descripcion:'',
                        naturaleza:'',
                        modal:false,         
                    }) 
                   }  else{
                    compra[campo] = objeto.value?objeto.value:objeto.id;  
                    compra.tipo = objeto.tipo;  
                    compra.concepto= objeto.tipo_nombre;                      
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:objeto.codigo,
                        movimiento_descripcion:objeto.label,
                        naturaleza:objeto.tipo_nombre,
                        modal:false,         
                    }) 

                   }
                  
                  break;    
        }
        
    }
    toggle_modal(index=0,catalogo="",campo=""){
    if(campo=='factura_id'&&parseInt(this.state.compra.cliente_id)==0){
        swal("Oops..", "Selecciona un Cliente");

    }else{
        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }  

        
    }   

    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            compra: {
                ...this.state.compra,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {

       api().get('/sat/formas_pago/2')
      .then(function(response)
      {
        if(response.status === 200)
        {
          self.setState({
            formas : response.data
          });
        }
      });
        let {compra} = this.state;
        api().get(`datos_facturacion/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {              


                   compra.cuenta_beneficiario=response.data.datos.cuenta;
                   compra.rfc_banco_beneficiario=response.data.banco.rfc;  
                    self.setState({
                          compra: compra,
                    });

                }

            });


         
        let id = this.props.id;
        let self = this;
              
        if(id > 0 && id != self.state.compra.id)
        {

            api().get(`movimientocac/${id}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        compra: response.data.movimientoca,
                        action: 'update',
                        factura:response.data.factura,
                        proveedor_codigo:response.data.cliente.codigo,
                        proveedor_descripcion:response.data.cliente.nombre,
                        saldo_proveedor:response.data.cliente.saldo,
                        factura_codigo:response.data.factura.factura,
                        factura_descripcion:response.data.factura.concepto,
                        movimiento_codigo:response.data.movimiento.codigo,
                        movimiento_descripcion:response.data.movimiento.nombre,
                        naturaleza:response.data.movimiento.naturaleza,
                        subtotal_documento:response.data.factura.subtotal,
                        impuesto_documento:response.data.factura.impuesto,
                        saldo_documento:response.data.factura.saldo,
                        saldo_original:response.data.factura.total,
                        productos:response.data.productos
                    });

                }

            });
        }
        else if(id == null && self.state.compra.id)
        {   
            console.log('Reset Modal');
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
           compra: {
                  id:0,
                cliente_id:0,
                movimiento_id:0,
                factura_id:0,
                importe:'0.00',
                descuento:'0.00',
                subtotal:'0.00',
                ieps:'0.00',
                impuestos:'0.00',
                total:'0.00',
                fecha: moment().format('Y-MM-DD'),
                concepto:'',
                referencia:'',
                tipo:1,
                forma_pago:1,
                rfc_ordenante:'',
                nombre_banco_extranjero:'',
                rfc_banco_beneficiario:'',
                cuenta_ordenante:'',
                cuenta_beneficiario:'',
                tipo_cadena_pago:'',
                correo:'',
                certificado_pago:'',
                cadena_pago:'',
                sello_pago:'',
                tipo_movimiento_id:1,
                             
            },
            factura:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"",
            naturaleza:'',
        });
        
    }
    handleInputChange(event) {
        let {compra,factura} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        compra[name] = value;
        if(name=='total')
        {
          let factor=factura.factor_impuesto?factura.factor_impuesto:0;
          let uno= parseFloat( compra.total)/(factor+100);
          

          compra.impuestos=this.trunc(uno*factor,2);
          compra.subtotal=this.trunc(uno*100,2);

          console.log("factor---->", factor )
          console.log("impuestos---->",parseFloat( compra.impuestos ))
          console.log("subtotal---->",parseFloat( compra.subtotal ))
          console.log("total---->",parseFloat( compra.total ))
        }
     
        this.setState({
            compra : compra
        });
    }
     trunc (sVal, nDec = 0) {
  // var s = x.toString()
  // var l = s.length
  // var decimalLength = s.indexOf('.') + 1
  // var numStr = s.substr(0, decimalLength + posiciones)
  // return Number(numStr)


    var n = parseFloat(sVal); 
    var s = "0.00"; 
    if (!isNaN(n)){ 
     n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
     s = String(n); 
     s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
     s = s.substr(0, s.indexOf(".") + nDec + 1); 
    } 
    return s; 
}

   objeto_mayusculas(objeto){
      for (var key in objeto) {
        if (objeto.hasOwnProperty(key)) {                    
          objeto[key] = String(objeto[key]).toUpperCase() ;
          if( String(objeto[key]).toUpperCase()==='NULL')
            objeto[key] ='';
        }
      }
      return objeto;
    }
   
   
handleSubmit(evt){
   evt.preventDefault();
        let {compra,factura} = this.state;
        if(parseInt(compra.cancelado)==1){
          swal("Oops..", "Movimiento Cancelado ","warning");
          return false;
        } 
        let action=this.state.action;
        
        let save=true;
        let mensaje=true;
        let dato="";
        let self = this;        
        
            // let check = ['referencia','concepto','fecha','rfc_ordenante','nombre_banco_extranjero','rfc_banco_beneficiario','cuenta_beneficiario','tipo_cadena_pago','correo',];
            // if(parseInt(factura.tipo_doc)==2){
             let  check = ['referencia','concepto','fecha'];
            // }

            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }
            check = [
            'cliente_id',
            'movimiento_id',
            ];
            if(save)
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(parseInt( value) == 0) {
                save = false;
                break;
            }
                
            }

        var patt = new RegExp("[a-zA-Z0-9]?[a-zA-Z0-9]{11}[a-zA-Z0-9]$", "i");      
         if(parseInt(factura.tipo_doc)!=2){   
            // if(compra.rfc_ordenante.length>11&&compra.rfc_ordenante.search(patt)==0){

            //   if(compra.rfc_banco_beneficiario.length>11&&compra.rfc_banco_beneficiario.search(patt)==0){

            //   }else{
            //     save=false;
            //     dato='RFC Banco Beneficiario';
            //   }

            // }else{
            //   save=false;
            //   dato='RFC Ordenante';
            // }
        }
        
          //   if(save && parseInt(compra.tipo)==1 ){
          //     console.log("compra--->",parseFloat(compra.cantidad));
          //     console.log('factura--->',parseFloat(factura.subtotal_numero));
          //     if( parseFloat(compra.cantidad)>parseFloat(factura.subtotal_numero))
          //     {
          //       dato= "Cantidad es mayor al del Documento a afectar";
          //       save=false;
          //     }
          //     if(parseFloat(compra.impuestos)>parseFloat(factura.impuesto_numero))
          //     {
          //       dato= "Impuesto es mayor al del Documento a afectar";
          //       save=false;
          //     }
          //      if(parseFloat(compra.total)>parseFloat(factura.saldo_numero))
          //     {
          //       dato= "total es mayor al del Documento a afectar";
          //       save=false;
          //     }
             
          // }

        // compra=this.objeto_mayusculas(compra);
        // compra.factura_id=1;

        if(save   ){

            api().post(`/validacion_movimientocac`, compra)
            .then(function(response)
            {  
               let validacion=response.data.validacion;
                let encontrado=response.data.encontrado[0];
              if(validacion||(parseInt(encontrado.id)===parseInt(compra.id) )){
        
                    self.props[action](compra, (data) => {

                      self.props.alerta({
                        mensaje:"Cargo / Abono se Guardado correctamente!",
                        tipo:"success",
                        creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                      self.resetModal();
                      self.props.cerrar();
                });
              }else{
                    swal("Oops..", "La referencia ya existe");
                }
            });
        }else{
          
            swal("Oops..", "Por favor Verificar el Campo "+dato );

        }
    }

    render() {
       let {compra,action}=this.state;
         let editar=true;
         if(action=='update')
          editar=false;
 
        return(
            <div className="view">
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Movimiento de Abono</h1>
                    </header>
                </div>
                 <form onSubmit={this.handleSubmit} >
                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                          <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientocaclientes.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"   >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>
                          <div className="row">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                         <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-3"> 
                                        <div className="form-group">
                                            <label className="d-block">Movimiento *:</label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="movimiento_codigo"
                                            value={this.state.movimiento_codigo}
                                            onChange={ this.ChangeCode}
                                            onBlur={this.handleClose}
                                            className="input_button"
                                            disabled={!editar}
                                            required
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(28,"Tipos de Movimiento","movimiento_id") }  } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="d-block">Movimiento: {this.state.movimiento_descripcion}</label>
                                    <label className="d-block">Naturaleza: {this.state.naturaleza}</label>
                                </div>
                                </div>

                            </div>
                                          
                         </div>
                          <div className="row mt-3 form_cliente">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Referencia *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="referencia"
                                    maxLength={25}
                                    value={compra.referencia} 
                                    onChange={this.handleInputChange}
                                    required  />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Concepto *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="concepto"
                                    maxLength={75}
                                    value={compra.concepto} 
                                    onChange={this.handleInputChange}
                                    required  />
                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className>Fecha *:</label>
                                <input
                                    type="date" 
                                    className="form-control"
                                    name="fecha"
                                    value={compra.fecha || ''}
                                    onChange={this.handleInputChange}
                                    required
                                   
                                />
                            </div>
                        </div>
                        </div>
                         <div className="row form_cliente">
                         <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Cliente *:</label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="proveedor_codigo"
                                            value={this.state.proveedor_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                            disabled={!editar}
                                            required
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(30,"Clientes","cliente_id") } } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.proveedor_descripcion}</label>
                                </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Factura:</label>
                                            <Input
                                            placeholder=""
                                            name="factura_codigo"
                                            value={this.state.factura_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                             className="input_button"
                                             disabled={!editar}

                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(32,"Facturas","factura_id") } } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.factura_descripcion}</label>
                                </div>
                                </div>

                            </div>               
                         </div>
                        <div className="row form_cliente">
                         <div className="col-md-4">
                            <div className="row">
                            </div>               
                         </div>
                         <div className="col-md-8 ">
                            <div className="row">
                               <div className="col-md-1">
                                 <div className="row">
                                 </div>               
                               </div>
                               <div className="col-md-7 mt-5">
                                  <div className="row">
                                  <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Subtotal Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.subtotal_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Impuestos Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.impuesto_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Original: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_original}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Cliente: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_proveedor}</Label></h5>
                                        </FormGroup>
                                    </div>
                                  </div>               
                               </div>
                               <div className="col-md-4">
                                  <div className="row">
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <Label>subtotal</Label>
                                                <Input
                                                placeholder=""
                                                type="number"
                                                name="subtotal"
                                                value={compra.subtotal} 
                                                onChange={this.handleInputChange}
                                                readOnly
                                                  />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <Label>+Impuestos</Label>
                                                <Input
                                                placeholder=""
                                                type="number"
                                                name="impuestos"
                                                value={compra.impuestos} 
                                                onChange={this.handleInputChange} readOnly />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-12">
                                        <FormGroup>
                                            <Label>Total *</Label>
                                                <Input
                                                placeholder=""
                                                type="number"
                                                name="total"
                                                value={compra.total} 
                                                onChange={this.handleInputChange}
                                                required  />
                                        </FormGroup>
                                    </div>
                                  </div>               
                               </div> 
                            </div>               
                         </div>                                          
                        </div>
                          </Col>
                        </Row>
                         
                          </div>

                          <br/>
                          <br/>
                          <br/>
                          <br/>

                          <div className="row">
                          <div className='col-5'>
                          <div className="row">
                          <div className="col-12"> 
                                <div className="form-group">
                                    <label className>Forma de Pago *:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="forma_pago"
                                        options={this.state.formas}
                                        value={parseInt(compra.forma_pago) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'forma_pago') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-12">
                            <FormGroup>
                                <Label>Cuenta del Emisor Ordenante *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cuenta_ordenante"
                                    maxLength={40}
                                    value={compra.cuenta_ordenante}
                                    onChange={ this.handleInputChange}
                                    required
                                    readOnly
                                    />
                            </FormGroup>
                        </div>
                            <div className="col-12">
                            <FormGroup>
                                <Label>RFC Emisor de Cuenta Ordenante *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rfc_ordenante"
                                    maxLength={13}
                                    value={compra.rfc_ordenante}
                                    onChange={ this.handleInputChange}
                                    required
                                    readOnly
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup>
                                <Label>Nombre Banco Ordenante *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="nombre_banco_extranjero"
                                    maxLength={75}
                                    value={compra.nombre_banco_extranjero}
                                    onChange={ this.handleInputChange}
                                    required
                                    readOnly
                                    />
                            </FormGroup>
                        </div>

                        <div className="col-12">
                            <FormGroup>
                                <Label>RFC del Banco de la Cta Benef. *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rfc_banco_beneficiario"
                                    maxLength={13}
                                    value={compra.rfc_banco_beneficiario}
                                    onChange={ this.handleInputChange}
                                    required
                                    readOnly
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup>
                                <Label>Cuenta del Beneficiario *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cuenta_beneficiario"
                                    maxLength={13}
                                    value={compra.cuenta_beneficiario}
                                    onChange={ this.handleInputChange}
                                    required
                                    readOnly
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup>
                                <Label>Tipo de Cadena de Pago *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="tipo_cadena_pago"
                                    maxLength={20}
                                    value={compra.tipo_cadena_pago}
                                    onChange={ this.handleInputChange}
                                    readOnly
                                    />
                            </FormGroup>
                        </div>
                       

                          </div>

                          </div>
                          <div className='col-7'>
                          <div className="row">
                          <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Certificado que ampara el pago</label>
                                    <Input
                                      rows={5}                                                        
                                      type="textarea"
                                      name="certificado_pago"
                                      value={compra.certificado_pago} 
                                      maxLength={150}
                                      onChange={ this.handleInputChange}
                                      readOnly
                                      />
                                    
                                </div>
                            </div>
                          <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Cadena Original del comprobante del pago </label>
                                    <Input
                                      rows={5}                                                        
                                      type="textarea"
                                      name="cadena_pago"
                                      value={compra.cadena_pago} 
                                      maxLength={150}
                                      onChange={ this.handleInputChange}
                                      readOnly
                                      />
                                    
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Sello digital que se asocie al pago </label>
                                    <Input
                                      rows={5}                                                        
                                      type="textarea"
                                      name="sello_pago"
                                      value={compra.sello_pago} 
                                      maxLength={150}
                                      onChange={ this.handleInputChange} 
                                      readOnly
                                      />
                                    
                                </div>
                            </div>

                          </div>
                          </div>

                          </div>

                           <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientocaclientes.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"   >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>

                         

                    
                        
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                        </CardBlock>
                    </Card>
                </div>
                </form>
                { this.state.modal&&
                 <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    cliente_id={this.state.compra.cliente_id}
                />
                }
                
            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientocaclientes : state.movimientocaclientes,
         notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(EmbarqueModal)


// WEBPACK FOOTER //
// ./src/views/movimientoscaclientes/abono.js